import { onFontsReady } from "../utils/onFontsReady";
import { initFontsGate } from "../utils/initFontsGate";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
initFontsGate("Manrope", [400, 700]);

function initFlexContent(section) {
	if (!section || section.dataset.gsapFlexInited) return;
	section.dataset.gsapFlexInited = "1";

	if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

	const desc = section.querySelector(".webvibe_content-description");
	const imgWrap = section.querySelector(".webvibe_content-image");
	const overlay = section.querySelector(".webvibe_image-overlay-inset");
	const img = imgWrap?.querySelector("img");

	const textItems = desc ? Array.from(desc.children) : [];

	// стартовые состояния
	if (textItems.length) gsap.set(textItems, { opacity: 0, y: 14 });
	if (imgWrap) gsap.set(imgWrap, { opacity: 0 });
	if (overlay) gsap.set(overlay, { opacity: 0 });
	if (img) gsap.set(img, { opacity: 0 }); // можно убрать, если не нужно

	const tl = gsap.timeline({
		defaults: { ease: "power2.out" },
		scrollTrigger: {
			trigger: section,
			start: "top 70%",
			once: true,
			invalidateOnRefresh: true,
		},
	});

	if (textItems.length) {
		tl.to(textItems, {
			opacity: 1,
			y: 0,
			duration: 0.65,
			stagger: 0.12,
			clearProps: "transform,opacity",
		});
	}

	if (imgWrap) {
		tl.to(
			imgWrap,
			{ opacity: 1, duration: 0.8, ease: "power1.out", clearProps: "opacity" },
			textItems.length ? "-=0.35" : 0
		);
	}

	if (img) {
		tl.to(
			img,
			{ opacity: 1, duration: 0.8, ease: "power1.out", clearProps: "opacity" },
			"<"
		);
	}

	if (overlay) {
		tl.to(
			overlay,
			{ opacity: 1, duration: 0.8, ease: "power1.out", clearProps: "opacity" },
			"<"
		);
	}
}

onFontsReady(() => {
	document.querySelectorAll(".wv-gsap-flex-content").forEach(initFlexContent);
	ScrollTrigger.refresh();
});
